"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
// eslint-disable-next-line func-names
window.ListBlock = function (opts) {
    /* contents of 'opts':
            definitionPrefix (required)
            childInitializer (optional) - JS initializer function for each child
        */
    var listMemberTemplate = jquery_1["default"]('#' + opts.definitionPrefix + '-newmember').text();
    // eslint-disable-next-line func-names
    return function (elementPrefix) {
        // eslint-disable-next-line no-undef, new-cap
        var sequence = Sequence({
            prefix: elementPrefix,
            maxNumChildBlocks: Infinity,
            onInitializeMember: function (sequenceMember) {
                /* initialize child block's JS behaviour */
                if (opts.childInitializer) {
                    opts.childInitializer(sequenceMember.prefix + '-value');
                }
                /* initialise delete button */
                jquery_1["default"]('#' + sequenceMember.prefix + '-delete').on('click', function () {
                    sequenceMember["delete"]();
                });
                /* initialise move up/down buttons */
                jquery_1["default"]('#' + sequenceMember.prefix + '-moveup').on('click', function () {
                    sequenceMember.moveUp();
                });
                jquery_1["default"]('#' + sequenceMember.prefix + '-movedown').on('click', function () {
                    sequenceMember.moveDown();
                });
            },
            onEnableMoveUp: function (sequenceMember) {
                jquery_1["default"]('#' + sequenceMember.prefix + '-moveup').removeClass('disabled');
            },
            onDisableMoveUp: function (sequenceMember) {
                jquery_1["default"]('#' + sequenceMember.prefix + '-moveup').addClass('disabled');
            },
            onEnableMoveDown: function (sequenceMember) {
                jquery_1["default"]('#' + sequenceMember.prefix + '-movedown').removeClass('disabled');
            },
            onDisableMoveDown: function (sequenceMember) {
                jquery_1["default"]('#' + sequenceMember.prefix + '-movedown').addClass('disabled');
            }
        });
        /* initialize 'add' button */
        jquery_1["default"]('#' + elementPrefix + '-add').on('click', function () {
            sequence.insertMemberAtEnd(listMemberTemplate);
        });
    };
};
